'use strict';

module.exports = {
  toolGenerated: 'tool-generated',
  userModified: 'user-modified',
};
